export default function () { 
  mobileSubmenus()
  window.onresize = mobileSubmenus
}

const submenuLinks = document.getElementsByClassName('main-menu__has-submenu')  

const mobileSubmenus = () => {
  if (window.innerWidth < 768) {
    Array.from(submenuLinks).forEach(submenu => {
      submenu.addEventListener('click', mobileSubmenuHandler)
    })
  } else {
    Array.from(submenuLinks).forEach(submenu => {
      submenu.removeEventListener('click', mobileSubmenuHandler)
    })
  }
}

const mobileSubmenuHandler = (e) => {
  let thisSubmenuLink = e.target.parentElement  

  if (thisSubmenuLink.classList.contains('main-menu__has-submenu')) {
    e.preventDefault()

    let thisSubmenu = thisSubmenuLink.querySelector('.main-menu__submenu')
    thisSubmenuLink.classList.toggle('link-active')
    thisSubmenu.classList.toggle('submenu-active')
  }
}